import React from 'react';
import BaseDivider from '@bit/medicalwebexperts.mwe-ui.divider';

const Divider = () => <BaseDivider my={8} />;

export default Divider;
